import React, { useEffect } from "react";
import styled from "styled-components";
import { Page, PageTitle } from "../components/PageLayout";
import SuperAdminOrganizationsTable from "../components/SuperAdminOrganizationsTable";
import QUERY_ORGANIZATIONS from "@sellout/models/.dist/graphql/queries/organizations.query";
import { useQuery } from "@apollo/react-hooks";
import PageLoader from "../components/PageLoader";
import { PaginationTypes } from "@sellout/models/.dist/interfaces/IPagination";
import PageSearch from "../components/PageSearch";
import GET_PLATFORM_SETTINGS from "@sellout/models/.dist/graphql/queries/platformSettings.query";
import { media } from "@sellout/ui/build/utils/MediaQuery";

const TableContainer = styled.div`
  display: flex;
  ${media.mobile`
    height: calc(100vh - 364px);
  `};
`;
export const SearchContainer = styled.div`
  margin: 0px 24px 24px 0px;
  display: flex;
  ${media.mobile`
   display: block;
  `};
`;
export enum OrganizationEnum {
  queryOrganization = "QUERY_ORGANIZATION",
  searchPlaceHolder = "Search by Org ID, Organizations Name",
}
type SuperAdminOrganizationsProps = {};

const SuperAdminOrganizations: React.FC<SuperAdminOrganizationsProps> = () => {
  /* State */
  const [searchQuery, setSearchQuery] = React.useState("");

  const query = {
    orgQuery: searchQuery,
    orgIds: [searchQuery],
    any: true,
  };
  /** Hooks */
  const { data, fetchMore, loading, refetch } = useQuery(QUERY_ORGANIZATIONS, {
    variables: {
      pagination: {
        pageSize: 60,
        pageNumber: 1,
      },
      query,
    },
    context: {
      debounceKey: OrganizationEnum.queryOrganization,
      debounceTimeout: 250,
    },
  });

  const { data: platformData } = useQuery(GET_PLATFORM_SETTINGS);

  /* Render */
  return (
    <>
      <PageLoader nav sideNav fade={Boolean(data?.organizations)} />
      <Page>
        <PageTitle>Organizations</PageTitle>
        <SearchContainer>
          <PageSearch
            setSearchQuery={setSearchQuery}
            searchQuery={searchQuery}
            loading={loading}
            placeHolder={OrganizationEnum.searchPlaceHolder}
          />
        </SearchContainer>
        <TableContainer>
          <SuperAdminOrganizationsTable
            organizations={data?.organizations}
            selloutWebFlowSiteId={platformData?.platformSettings?.webFlowSiteId}
            fetchMore={fetchMore}
            refetch={refetch}
          />
        </TableContainer>
      </Page>
    </>
  );
};

export default SuperAdminOrganizations;
